import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement } from "react";
import { useStyles } from "./LabelButton.styles";
const LabelButton = ({ text, color, onClick, icon: Icon, ...rest }) => {
    const { classes } = useStyles({ color, Icon });
    return (_jsxs("div", { className: classes.container, onClick: onClick, children: [Icon && cloneElement(Icon, { className: `${classes.icon}` }), _jsx("span", { className: classes.text, ...rest, children: text })] }));
};
export default LabelButton;
